
/**
 * localStorage / sessionStorage fallback
 * (ie <= 8 / Safari private browsing)
 */

const TEST_KEY = '__TEST_KEY__'
const TEST_DATA = '1234'

/**
 * Checks if the current browser has *Storage
 * @param  String  name
 * @return Boolean
 */
function isStorageAvailable(name) {
    try {
        const storage = window[name]
        storage.setItem(TEST_KEY, TEST_DATA)
        const result = storage.getItem(TEST_KEY)
        storage.removeItem(TEST_KEY)
        return result === TEST_DATA
    } catch (e) {
        return false
    }
}

/**
 * Gives the requested storage or in-memory fallback
 * @param  String name
 * @return Storage
 */
function getStorage(name) {
    if ( isStorageAvailable(name) ) {
        return window[name]
    }

    return new MemoryStorage()
}

/**
 * Simple in-memory storage mock
 */
class MemoryStorage {
    constructor() {
        this._data = {}
    }

    getItem(key) {
        return this._data.hasOwnProperty(key) ? this._data[key] : undefined
    }

    setItem(key, value) {
        return this._data[key] = String(value)
    }

    removeItem(key) {
        return delete this._data[key]
    }

    clear() {
        return this._data = {}
    }
}

export default {
    local: getStorage('localStorage'),
    session: getStorage('sessionStorage')
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/storage.js